import { Card, Table, TableContainer, TablePagination } from '@mui/material';
import { useState } from 'react';
import Scrollbar from 'src/components/scrollbar/Scrollbar';
import DynamicHeightComponent from 'src/utils/dynamicSize.component';
import NoApproval from '../../../assets/app-image/no-approval-posts.svg';
import RejectedApprovalGridBody from './rejected-post-grid-body.component';
import RejectedApprovalGridHead from './rejected-post-grid-head.component';

const RejectedApprovalGrid = ({
  rejectedApprovalList,
  isOrgEvent,
  handleReCallRejectedApprovalPost,
  order,
  orderBy,
  isShowOfferBanner=false 
}) => {
  //Table Variables
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [height, setHeight] = useState(window.innerHeight - 110);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    let orderStr = isAsc ? 'desc' : 'asc';
    handleReCallRejectedApprovalPost(property, orderStr);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  return (
    <>
      {rejectedApprovalList && rejectedApprovalList.length > 0 ? (
        <>
          <DynamicHeightComponent heightRatio={110}>
            <Scrollbar>
              <TableContainer
                sx={{
                  height: isShowOfferBanner ? 'calc(94vh - 226px)' : 'calc(94vh - 226px)',
                }}
              >
                <Table stickyHeader size="small">
                  <RejectedApprovalGridHead
                    rejectedApprovalList={rejectedApprovalList}
                    orderBy={orderBy}
                    order={order}
                    handleRequestSort={handleRequestSort}
                  ></RejectedApprovalGridHead>
                  <RejectedApprovalGridBody
                    rejectedApprovalList={rejectedApprovalList}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    isOrgEvent={isOrgEvent}
                    handleReCallRejectedApprovalPost={handleReCallRejectedApprovalPost}
                  ></RejectedApprovalGridBody>
                </Table>
              </TableContainer>
              <TablePagination
                component="div"
                rowsPerPageOptions={[10, 20, 30, 50]}
                count={rejectedApprovalList.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Scrollbar>
          </DynamicHeightComponent>
        </>
      ) : (
        <Card
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: 'calc(100vh - 150px)',
            maxHeight: 'calc(100vh - 150px)',
          }}
        >
          <img
            src={NoApproval}
            style={{ width: '50%', height: '50%', maxWidth: '50%', maxHeight: '50%' }}
            alt="No Rejected Approval"
          />
        </Card>
      )}
    </>
  );
};
export default RejectedApprovalGrid;
